// ActionTypes
export const BoletoActionTypes = {
  ASYNC_BOLETOS: '@boletos/ASYNC_BOLETOS',
  GET_BOLETOS: '@boletos/GET_BOLETOS',
  LOADING: '@boletos/LOADING',

  ASYNC_BOLETOS_SUMMARY: '@boletos/ASYNC_BOLETOS_SUMMARY',
  GET_BOLETOS_SUMMARY: '@boletos/GET_BOLETOS_SUMMARY',
  LOADING_SUMMARY: '@boletos/LOADING_SUMMARY',
};

const INITIAL_STATE = {
  boletos: [],
  boletosTotal: 0,
  loading: false,

  boletosSummary: {
    generated: 0,
    overdue: 0,
    paid: 0,
  },
  loadingSummary: false,
};

const TicketReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case BoletoActionTypes.GET_BOLETOS:
      return {
        ...state,
        boletos: payload?.items ?? [],
        boletosTotal: Number(payload?.total ?? 0),
      };

    case BoletoActionTypes.LOADING:
      return { ...state, loading: !!payload };

    case BoletoActionTypes.GET_BOLETOS_SUMMARY:
      return {
        ...state,
        boletosSummary: {
          generated: Number(payload?.generated ?? 0),
          overdue: Number(payload?.overdue ?? 0),
          paid: Number(payload?.paid ?? 0),
          totalGenerated: Number(payload?.totalGenerated ?? 0),
          totalOverdue: Number(payload?.totalOverdue ?? 0),
          totalPaid: Number(payload?.totalPaid ?? 0),
        },
      };

    case BoletoActionTypes.LOADING_SUMMARY:
      return { ...state, loadingSummary: !!payload };

    default:
      return state;
  }
};

export default TicketReducer;

export const asyncBoletos = (payload) => ({
  type: BoletoActionTypes.ASYNC_BOLETOS,
  payload,
});

export const setBoletos = (payload) => ({
  type: BoletoActionTypes.GET_BOLETOS,
  payload,
});

export const setLoading = (payload) => ({
  type: BoletoActionTypes.LOADING,
  payload,
});

export const asyncBoletosSummary = (payload) => ({
  type: BoletoActionTypes.ASYNC_BOLETOS_SUMMARY,
  payload,
});

export const setBoletosSummary = (payload) => ({
  type: BoletoActionTypes.GET_BOLETOS_SUMMARY,
  payload,
});

export const setLoadingSummary = (payload) => ({
  type: BoletoActionTypes.LOADING_SUMMARY,
  payload,
});
